const geoJSON = `
{
  "type":"FeatureCollection",
  "features": [
    {
      "type":"Feature",
      "geometry": {
        "type":"Polygon",
        "coordinates": [
          [
            [
              50.828155,
              9.729663
            ],
            [
              50.838155,
              9.7296639
            ],
            [
              50.838155,
              9.739663
            ],
            [
              50.828155,
              9.7396639
            ],
            [
              50.828155,
              9.729663
            ]
          ]
        ]
      },
      "properties":{
        "id":6,
        "measurement":0.0
      }
    }
  ]
}`;

export default JSON.parse(geoJSON);
